import { MouseEvent } from 'react';
import Image from 'global/Image';

import BaseSecuritiesModal from 'global/Securities/components/Modal/BaseSecuritiesModal';
import type { BaseSecuritiesModalProps } from 'global/Securities/components/Modal/BaseSecuritiesModal';

import {
  Container,
  ContentWrapper,
  Description,
  FinishButton,
  Title,
} from './success.styled';

const CreatePortoSuccess = ({
  onCancel = () => {},
  onSubmit = () => {},
  ...props
}: BaseSecuritiesModalProps) => {
  const handleSubmit = () => {
    onSubmit();
  };

  const handleCancel = (e: MouseEvent<HTMLElement>) => {
    onCancel(e);
  };

  return (
    <BaseSecuritiesModal
      hideSubmit
      onCancel={handleCancel}
      className="modal-multi-porto"
      transitionName=""
      {...props}
    >
      <Container onClick={(e) => e.stopPropagation()}>
        <Image src="/images/multi-porto/success-create-porto.svg" alt="" />

        <ContentWrapper>
          <Title>Portofolio Baru Kamu Telah Diajukan</Title>
          <Description>
            Proses ini membutuhkan verifikasi selama 1 hari kerja.
          </Description>
        </ContentWrapper>

        <FinishButton onClick={handleSubmit} type="primary">
          OK
        </FinishButton>
      </Container>
    </BaseSecuritiesModal>
  );
};

export default CreatePortoSuccess;
